export default {
  heading: 'Inter Variable, -apple-system, system-ui, sans-serif',
  body: 'Inter Variable, -apple-system, system-ui, sans-serif',
}
